
export const counterLogConstants = {
    FETCH_COUNTER_BY_PRINTER_REQUEST: "FETCH_COUNTER_BY_PRINTER_REQUEST",
    FETCH_COUNTER_BY_PRINTER_SUCCESS: "FETCH_COUNTER_BY_PRINTER_SUCCESS",
    FETCH_COUNTER_BY_PRINTER_FAILURE: "FETCH_COUNTER_BY_PRINTER_FAILURE",
 
    CLEAR_ERRORS: "CLEAR_ERRORS",
};
